import { HOST, } from "common/constants";
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  CircularProgress,
  Box,
  Breadcrumbs,
} from "@mui/material";
import axios from "axios";
import { ArrowRight, ChevronRight } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { BackButton } from "components/UI/BackButton";

const OrgansRegionId = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation(); // Подключаем переводчик

  const [regionData, setRegionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDistricts = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${HOST}/api/v1/resolutions/regions/${id}/`
        );
        setRegionData(response.data);
      } catch (err) {
        setError(
          t("errorLoadingDistricts") || "Не удалось загрузить данные районов"
        );
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchDistricts();
  }, [id, t]);

  // Функция для динамического получения заголовка
  const getLocalizedTitle = (item) => {
    if (!item) return "";
    const lang = i18n.language; // 'ru', 'ky' или 'en'
    
    // Формируем ключ динамически: title_ru, title_ky или title_en
    const localizedField = item[`title_${lang}`];
    
    // Если поле существует и оно не null, возвращаем его. 
    // Иначе откатываемся на базовый title или title_ru
    return localizedField || item.title || item.title_ru || "";
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography color="error">{error}</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <BackButton />

      <Breadcrumbs separator={<ChevronRight fontSize="small" />} sx={{ mb: 2 }}>
        <Link to="/organs" style={{ textDecoration: "none", color: "inherit" }}>
          {t("msuBodies")}
        </Link>
        <Typography color="text.primary">
          {getLocalizedTitle(regionData)}
        </Typography>
      </Breadcrumbs>

      <Typography variant="h4" gutterBottom>
        {t("districtsIn") || "Районы:"} {getLocalizedTitle(regionData)}
      </Typography>

      <List>
        {regionData?.districts.map((district) => (
          <ListItem key={district.id} disablePadding divider>
            <ListItemButton
              component={Link}
              to={`/organs/districts/${district.slug}`}
            >
              <ListItemText
                primary={getLocalizedTitle(district)}
              />
              <Box>
                <ArrowRight />
              </Box>
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {regionData?.districts.length === 0 && (
        <Typography sx={{ mt: 2, color: "text.secondary" }}>
          {t("noDistrictsFound") || "В данной области районы не найдены."}
        </Typography>
      )}
    </Container>
  );
};

export default OrgansRegionId;